var __asyncValues = this && this.__asyncValues || function (o) {
    if (!Symbol.asyncIterator)
        throw new TypeError('Symbol.asyncIterator is not defined.');
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === 'function' ? __values(o) : o[Symbol.iterator](), i = {}, verb('next'), verb('throw'), verb('return'), i[Symbol.asyncIterator] = function () {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function (v) {
            return new Promise(function (resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function (v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
import {
    CheckedNumber,
    checkedNumberConvert as convert,
    Guid,
    guidConvert
} from '@ef-carbon/primitive';
import FormationMap from './formation/Map';
export class Cache {
    constructor({data, provider, limit}) {
        this.provider = provider;
        this.checkedLimit = new CheckedNumber(limit !== undefined ? convert(limit) : Cache.limit, { min: 0 });
        this.map = new FormationMap(data);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.map.enumerable = false;
        descriptors.checkedLimit.enumerable = false;
        Object.defineProperties(this, descriptors);
    }
    get limit() {
        return +this.checkedLimit;
    }
    set limit(value) {
        this.checkedLimit.value = value;
    }
    miss(id, options) {
        return this.provider.fetch(id, options);
    }
    async fetch(id, options) {
        var e_1, _a;
        const converted = guidConvert(id);
        const previous = this.map.get(converted);
        if (previous) {
            return previous;
        }
        let limit = this.limit;
        let found;
        try {
            for (var _b = __asyncValues(this.miss(new Guid(converted), options)), _c; _c = await _b.next(), !_c.done;) {
                const formation = _c.value;
                const formationId = `${ formation.id }`;
                if (formationId === converted) {
                    found = formation;
                } else if (--limit > 0) {
                    this.map.set(formationId, formation);
                } else if (found) {
                    break;
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    await _a.call(_b);
            } finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        if (!found) {
            throw new RangeError(`Failed to fetch formation '${ id }'`);
        }
        this.map.set(`${ found.id }`, found);
        this.shrink(+this.limit);
        return found;
    }
    get(id) {
        const converted = guidConvert(id);
        return this.map.get(converted);
    }
    get size() {
        return this.map.size;
    }
    clear() {
        this.map.clear();
    }
    shrink(size) {
        let amount = this.size - size;
        if (amount <= 0) {
            return;
        }
        for (const key of this.keys()) {
            this.map.delete(key);
            if (!--amount) {
                break;
            }
        }
    }
    has(id) {
        const converted = guidConvert(id);
        return this.map.has(converted);
    }
    forEach(callback, thisArg) {
        this.map.forEach(callback, thisArg);
    }
    keys() {
        return this.map.keys();
    }
    values() {
        return this.map.values();
    }
    entries() {
        return this.map.entries();
    }
    [Symbol.iterator]() {
        return this.map[Symbol.iterator]();
    }
    [Symbol.toStringTag]() {
        return this.constructor.name;
    }
    toJSON(_ = '') {
        return Array.from(this.keys());
    }
    store(formation) {
        this.map.set(`${ formation.id }`, formation);
        this.shrink(+this.limit);
    }
}
Cache.limit = 128;
export default Cache;    //# sourceMappingURL=Cache.js.map
